import { parsePhoneNumberWithError } from "libphonenumber-js";
import { toast } from "sonner";

export const formatPhoneNumber = (
    number: string,
    format: "INTERNATIONAL" | "E.164" = "INTERNATIONAL",
    silent = true
) => {
    try {
        const parsedNumber = parsePhoneNumberWithError(number);
        if (!parsedNumber) return number;

        return parsedNumber.format(format);
    } catch (error) {
        if (!silent) {
            toast.error("Invalid phone number");
            throw error;
        }
        // Return original number if parsing fails and we're in silent mode
        return number;
    }
};
